export { default } from "./TextWithNewLines";
